import React, { PureComponent, Fragment } from "react";
import { formatNumber } from "../Utils/utils";
import List from "./list";
export default class CardFormSecureInvs extends PureComponent {
  render() {
    const { items, openModalPdf } = this.props;
    let type = "";
    let validate = items.pension && items.tv ? true : false;
    let plan = "";
    switch (items.pensionPeriod) {
      case "12":
        type = "Mensual";
        break;
      case "4":
        type = "Trimestral";
        break;
      case "3":
        type = "Cuatrimestral";
        break;
      case "2":
        type = "Semestral";
        break;
      case "1":
        type = "Anual";
        break;
    }

    switch (items.planes) {
      case "PLAN_PENSION_FAMILIAR":
        plan = "Plan pensión familiar";
        break;
      case "PLAN_CON_DEVOLUCION_DE_PRIMA":
        plan = "Plan con devolución de prima";
        break;
      case "PLAN_CON_DEVOLUCION_INTEGRAL":
        plan = "Plan con devolución integral";
        break;
      case "PLAN_CON_PENSION_MAXIMA":
        plan = "Plan con pensión máxima";
        break;
      case "PLAN_CON_DEVOLUCION_EN_VIDA":
        plan = "Plan con devolución en vida";
        break;
      case "PLAN_PENSION_PERMANENTE":
        plan = "Plan pensión permanente";
        break;
    }

    return (
      <section className="modaldata">
        <div className="modaldata__content">
          <div className="modaldata__balance">
            <div className="balance__title">Pensión {type}</div>
            <span className="balance__currency">
              {items.money_rg === "PEN" ? "S/" : "$"}
            </span>
            <span className="balance__amount">
              {items.pension ? formatNumber.new(parseFloat(items.pension)) : 0}
            </span>
          </div>
          <List>
            <li>
              <b>Tasa De Venta:&nbsp;</b> {items.tv ? items.tv : 0}%
            </li>
            <li>
              <b>Plan:&nbsp; {plan}</b>{" "}
            </li>
            <li>
              <b>
                {items.defermentMonths && validate ? items.defermentMonths : 0}{" "}
                meses de diferimiento
              </b>
            </li>
            <li>
              <b>
                {items.doublePaymentMonths && validate
                  ? items.doublePaymentMonths
                  : 0}{" "}
                meses de doble pago
              </b>
            </li>
            <li>
              <b>
                {items.ajuste_pension === "true"
                  ? "Si aplica ajuste de pensión"
                  : "No aplica ajuste de pensión"}
              </b>
            </li>
          </List>
          <div className="link-sep">
            <span className="modaldata__link" onClick={() => openModalPdf()}>
              Ver cotizaciones
            </span>
          </div>
        </div>
      </section>
    );
  }
}
